import React, { useEffect } from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function Toast({ kind = "success", msg, onDone, duration = 4200 }) {
  useEffect(() => {
    const t = setTimeout(() => onDone?.(), duration);
    return () => clearTimeout(t);
  }, [onDone, duration]);

  const isErr = kind === "error";
  return (
    <div
      className={`fixed top-6 right-6 z-[200] pm-card pm-glow-ring px-4 py-3 flex items-center gap-3 max-w-sm shadow-xl ${
        isErr ? "border-red-500/40" : ""
      }`}
      data-testid={`toast-${kind}`}
    >
      {isErr ? (
        <AlertCircle className="text-red-400 shrink-0" size={20} />
      ) : (
        <CheckCircle2 className="text-[color:var(--pm-neon)] shrink-0" size={20} />
      )}
      <span className="text-sm text-white/90">{msg}</span>
    </div>
  );
}
